import { createRelatedLinks } from '@vfde-brix/ws10/related-links';
import { createComponentById, NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/ws10/core';
import { HtmlId } from '../enums/elementId';

export const mountRelatedLinks = (id: HtmlId) =>
    createComponentById(createRelatedLinks, id, NO_PATTERN_BUSINESS_LOGIC);
